/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type MemberDetailResponseDocumentTheme = typeof MemberDetailResponseDocumentTheme[keyof typeof MemberDetailResponseDocumentTheme];


export const MemberDetailResponseDocumentTheme = {
  dark: 'dark',
  light: 'light',
} as const;
